export const tooltipThemeDefinition = () => ({
    MuiTooltip: {
        defaultProps: {
            arrow: true,
        },
        styleOverrides: {
            root: {},
        },
    },
});
//# sourceMappingURL=tooltipThemeDefinition.js.map